export default "__VITE_ASSET__V70G73FL__"